<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import { required } from "vuelidate/lib/validators";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal";
import planificacionAuditoriasAPI from "../../../services/standards/planificacionAuditorias/planificacionAuditoriasAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "6.1.4 Planificación Auditorías con el COPASST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {
    return {
      title: "6.1.4 Planificación Auditorías con el COPASST",
      items: [
        {
          text: "Estandares",
          href: "/",
        },
        {
          text: "Planificación Auditorías con el COPASST",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/planificacion-auditorias`,
        },
        {
          text: "Editar",
          active: true,
        },
      ],
      lista: [],
      file: null,
      itemData: null,
      acta: null,
      submitted: false,
      planificacion: {
        observations: null,
        file: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      loading: true,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,
    };
  },
  validations: {
    file: {
      required,
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(56)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let name = "";
        let url = "";

        if (!this.file) {
          if (this.planificacion.file) {
            name = this.getFile(this.planificacion.file);
          } else {
            throw new Error("No se ha seleccionado un archivo y no hay un archivo previo.");
          }
        } else {
          name = this.file.name;
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/6.1.4/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/6.1.4/${this.$route.params.id}/${name}`;
        }

        if (!this.file) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.planificacion.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else {
            return false;
          }
        }
      } catch (error) {
        console.log(error.message || error);
        return false;
      }
    },

    getPlanificacion() {
      planificacionAuditoriasAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.planificacion = {
            observations: response.data.observations,
            file: response.data.file,
            companies_id: response.data.companies_id,
          };
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async update() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        planificacionAuditoriasAPI
          .update(this.$route.params.id, {
            observations: this.planificacion.observations,
            file: this.planificacion.file,
            companies_id: this.planificacion.companies_id,
          })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 56,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Informacion actualizada con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  this.$router.go(-1);
                }, 1000);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            title: "¡No se ha podido registrar!",
            type: "warning",
            icon: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    goBack() {
      this.$router.go(-1);
    },

  },

  mounted() {
    this.getPlanificacion();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row px-3">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-12 px-2" label="Cargar plan de auditoría" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" drop-placeholder="Suelta acá..."
                      :placeholder="planificacion.file ? getFile(planificacion.file) : `Selecciona un archivo...`"
                      @change="uploadFile" v-on:change="uploadFile" v-model="file"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="Observaciones">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description" maxlength="200"
                      v-model="planificacion.observations">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
